import type { BaseMetadata, ThreadData } from "@liveblocks/client"
import { isDefined } from "@prismicio/editor-support/Type"
import type { TextBlock } from "@prismicio/types-internal/lib/content"
import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"
import { mergeAttributes } from "@tiptap/core"
import TTBulletList from "@tiptap/extension-bullet-list"
import type { Node as ProsemirrorNode, Schema } from "@tiptap/pm/model"

import { ListItem } from "../../coreExtensions"
import { converter as TextDirection } from "../../globalExtensions/TextDirection"
import { ListExtension, NodeUtils } from "../../models"

const component = TTBulletList.extend({
  name: "bulletList",
  parseHTML() {
    return [
      {
        tag: "ul",
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "ul",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ]
  },
}).configure({
  itemTypeName: "listItem",
})

const converter = {
  fromPrismic(
    id: string,
    schema: Schema,
    threads?: ThreadData<BaseMetadata>[],
  ): (bulletList: TextBlock) => ProsemirrorNode | undefined {
    return function (bulletList: TextBlock): ProsemirrorNode | undefined {
      const content = ListItem.converter.fromPrismic(
        id,
        schema,
        threads,
      )(bulletList)
      if (!content) return

      return schema.nodes[component.name]?.create(
        TextDirection.fromPrismic(bulletList),
        content,
      )
    }
  },

  toPrismic(node: ProsemirrorNode): readonly TextBlock[] {
    return NodeUtils.children
      .map(node, (child: ProsemirrorNode) => {
        return ListItem.converter
          .toPrismic(child, RichTextNodeType.list)
          .filter(isDefined)
      })
      .flat()
  },
}
const EditorBulletList = new ListExtension(
  [RichTextNodeType.list],
  component.name,
  component,
  converter,
)

// eslint-disable-next-line import/no-default-export
export default EditorBulletList
